import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { ModalService } from 'src/app/core/services/modal.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import { EnterConfirmIdComponent } from '../enter-confirm-id/enter-confirm-id.component';
import { BarcodeScanner, CameraDirection } from '@capacitor-community/barcode-scanner';
import { FarmSaveFormComponent } from '../farm-save-form/farm-save-form.component';
import { LoadingService } from 'src/app/core/services/loading.service';
import { FindFieldComponent } from '../find-field/find-field.component';
import { ComponentRef, ModalOptions } from '@ionic/core';
import { ParcelInquiryComponent } from '../parcel-inquiry/parcel-inquiry.component';
import { ClientAlertService } from 'src/app/core/services/client-alert.service';
import { LanguageService } from 'src/app/core/services/lang.service';
import { environment } from 'src/environments/environment';
import { ImportFarmDeviceService } from '../../services/import-farm-device.service';
import { PermissionService } from 'src/app/core/services/permission.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { Message_Type } from 'src/app/core/models/enums/message-type';

@Component({
  selector: 'app-enter-device',
  templateUrl: './enter-device.component.html',
  styleUrls: ['./enter-device.component.scss'],
})
export class EnterDeviceComponent {
  queryParam: Subscription;
  initialPage: number = 1;
  isFilizMode: boolean = false;
  isTorch: boolean = false;
  deviceID: string;
  direction: CameraDirection.FRONT | CameraDirection.BACK = CameraDirection.BACK
  show: boolean = true;
  loadStorage: boolean = false;
  mode: string;
  savedFarmItem: any;
  type: string;
  tempFarm: any;
  constructor(private activatedRoute: ActivatedRoute, private router: Router,
    private storageService: StorageService, private modalService: ModalService,
    private utilsService: UtilsService, private loadingService: LoadingService,
    private alertService: ClientAlertService, private langService: LanguageService,
    private importDevicFarmService: ImportFarmDeviceService,
    private permissionService: PermissionService, private toastService: ToastService,
    private translateService: TranslateService) { }

  ionViewDidEnter() {
    this.storageService.get(StorageKeys.FILIZ_MODE).then(res => {
      if (res.IsSuccess) {
        this.isFilizMode = res.Data;
      }
      this.loadStorage = true;
    });
    this.queryParam = this.activatedRoute.queryParams.subscribe(e => {
      if (e["initialPage"]) {
        this.initialPage = +e["initialPage"];

      }
      if (e["deviceId"]) {
        this.deviceID = e["deviceId"];
      }
      if (e["tempFarmAttrId"]) {
        this.tempFarm = +e["tempFarmAttrId"];
      }
      if (e["mode"]) {
        this.mode = e["mode"];
      }
      if (e["type"]) {
        this.type = e["type"];
        if (this.type == "import-field") {
          this.openAddField();
        }
      }
    });
  }


  openAddField() {
    this.modalService.presentModal({
      component: FindFieldComponent,
      componentProps: {
        type: this.type,
        isFilizMode: this.isFilizMode
      },
      options: {
        initialBreakpoint: 0.8,
        swipeToClose: false,
        mode: "ios",
        cssClass: "modal-radius"

      } as ModalOptions<ComponentRef>
    }).then(response => {
      response.modalObj.onDidDismiss().then(dismissProps => {
        if (dismissProps) {
          if (dismissProps.role == "startParcelInquiry") {
            this.startParcelInquery();
          } else if (dismissProps.role == "drawLocationSelected") {
            this.router.navigate(["/common/add-field"], {
              queryParams: { type: dismissProps.role }
            });
          } else if (dismissProps.role == "importFarm") {

            this.mode = dismissProps.role;
            this.initialPage = 4;
            this.savedFarmItem = dismissProps.data;
            this.importFarm();

          } else if (dismissProps.role == "addDevice") {
            this.mode = dismissProps.role;
            this.initialPage = 2;
            this.savedFarmItem = dismissProps.data;
            this.tempFarm = this.savedFarmItem?.TempFarmAttId
          }

        }
      });
    });
  }

  importDevice() {
    let deviceType: string = this.isFilizMode ? "filiz" : "trap"
    this.loadingService.showLoading();
    this.importDevicFarmService.farmAddDevice({ TempFarmAttId: this.tempFarm, DeviceId: this.deviceID, DeviceType: deviceType }).subscribe(res => {
      this.loadingService.hideLoading();
      if (res.IsSuccess) {
        this.storageService.set(StorageKeys.mapUpdated, true).then();
        if (deviceType == 'filiz') {
          this.storageService.set(StorageKeys.LAST_FILIZ_FARM, this.tempFarm);
        } else {
          this.storageService.set(StorageKeys.LAST_TRAP_FARM, this.tempFarm);
        }

        this.initialPage = 4;
      }
    });
  }

  importFarm() {
    this.loadingService.showLoading();
    if (this.savedFarmItem.CampaingId != environment.campaignId || this.savedFarmItem.CampaingId != 195) {
      this.importDevicFarmService.shareFarm({ TempFarmAttId: this.savedFarmItem.TempFarmAttId }).subscribe(e => {
        this.loadingService.hideLoading();
        if (e.IsSuccess) {
          this.storageService.set(StorageKeys.mapUpdated, true).then();
          if (this.savedFarmItem.Info) {
            this.initialPage = 4;
            this.storageService.lastFilizFarmId = null;
            this.storageService.lastTrapFarmId = null;
          } else {
            this.initialPage = 2;
            this.mode = "addDevice";
            this.storageService.lastFilizFarmId = null;
            this.storageService.lastTrapFarmId = null;
          }
        }
      });
    }
  }


  startParcelInquery() {
    this.modalService.presentModal({
      component: ParcelInquiryComponent,
      componentProps: {},
      options: ModalService.defaultOptions
    }).then(response => {
      response.modalObj.onDidDismiss().then(dismissResponse => {
        if (dismissResponse.role == 'canceled') {
          this.openAddField()
        } else if (dismissResponse.role == 'areaFound') {
          this.router.navigate(["/common/add-field"], {
            queryParams: { type: "parcelInquery" }
          });

        } else if (dismissResponse.role == 'areaNotFound') {
          let inquiryAgainCallback = (ev, modalId) => {
            this.modalService.dismissByModalId(modalId, {}, "buttonClicked")
            this.startParcelInquery()
          }

          let cancelCallback = (ev, modalId) => {
            this.modalService.dismissByModalId(modalId, {}, "buttonClicked")
            this.openAddField()
          }
          this.alertService.PresentAlert({
            buttons: [
              { callback: inquiryAgainCallback, color: "primary", fill: "solid", text: this.langService.getTranslation("add_field.inquiry_again_btn") },
              { callback: cancelCallback, color: "dark", fill: "clear", text: this.langService.getTranslation("general.cancel") }
            ],
            description: this.langService.getTranslation("add_field.parcel_not_found_desc"),
            title: this.langService.getTranslation("add_field.parcel_not_found_title"),
            image: "assets/images/not_found_image_1.svg"
          }, false).then(response => { })
        }
      });
    });
  }

  onFlashlight() {
    BarcodeScanner.enableTorch();
    this.isTorch = true;

  }
  offFlashlight() {
    this.isTorch = false;
    BarcodeScanner.disableTorch();
  }

  ionViewDidLeave() {
    if (this.queryParam) {
      this.queryParam.unsubscribe();
    }
    this.loadStorage = false;
  }

  // openAddField() {
  //   this.router.navigate(["/common/add-field"], {
  //     queryParams: { deviceId: this.deviceID }
  //   });
  // }

  openAddFieldForm() {
    let options = ModalService.defaultOptions;
    this.storageService.get(StorageKeys.DRAW).then(e => {
      if (e.IsSuccess) {
        let farmGeoJson = e.Data.geoJson;
        let calculatedArea = e.Data.calculatedArea;
        options.backdropDismiss = false
        options.showBackdrop = true
        options.cssClass = 'modal-half modal-radius'
        options.initialBreakpoint = 0.98
        this.modalService.presentModal({
          component: FarmSaveFormComponent,
          componentProps: {
            farmGeoJson: farmGeoJson,
            calculatedArea: calculatedArea,
            deviceId: this.deviceID,
            type: this.isFilizMode ? "filiz" : "trap"
          },
          options
        });
      }
    })

  }


  enterManually(deviceId?) {
    let modalId = Date.now();
    let header = deviceId ? "device-field-add.confirm-id" : "device-field-add.enter-id-manually";
    let button = deviceId ? "device-field-add.confirm" : "device-field-add.save";
    this.modalService.presentModal({
      component: EnterConfirmIdComponent,
      id: modalId,
      componentProps: {
        header: header,
        deviceID: deviceId,
        button: button,
        type: this.isFilizMode ? "filiz" : "trap"
      },
      options: ModalService.defaultOptionsTransparent
    }).then(modal => {
      this.modalService.modalOnDidDismiss(modalId).then(e => {
        if (e.data) {
          this.deviceID = e.data;
          if (this.mode == "addDevice") {
            this.importDevice();
          } else {
            this.initialPage = 3;
          }
        }
      });
    });
  }


  gotoHome() {
    if (this.isFilizMode) {
      this.router.navigate(["/filiz/home"], {
        queryParams: {
          isImportFarm: true
        }
      });
    } else {
      this.router.navigate(["/pesttrapp/home"], {
        queryParams: {
          isImportFarm: true
        }
      });
    }
  }


  startScan() {
    this.permissionService.requestCameraPermission("CAMERA").subscribe(permission => {
      if (permission) {
        this.show = false;
        document.body.style.setProperty('background-color', 'transparent');
        const result = BarcodeScanner.startScan().then(e => {
          this.show = true;
          document.body.style.removeProperty('background-color');
          if (e.hasContent) {
            // let data = JSON.parse(e.content);
            // if (data.DeviceId) {
            this.deviceID = e.content;
            this.enterManually(this.deviceID);
            // }
          }
        });
      }
      // else {
      //   this.toastService.PresentBasicToast({
      //     message: this.translateService.instant("general.permission-error-camera"),
      //     duration: 3500,
      //     type: Message_Type.WARNING
      //   });
      // }
    });

  }

  changeDirection() {
    this.direction = this.direction == CameraDirection.BACK ? CameraDirection.FRONT : CameraDirection.BACK;
    BarcodeScanner.stopScan().then(e => {
      BarcodeScanner.startScan({ cameraDirection: this.direction }).then(e => {
        if (e.hasContent) {
          let data = JSON.parse(e.content);
          if (data.DeviceId) {
            this.deviceID = data.DeviceId;
            this.enterManually(this.deviceID);
          }
        }
      });
    });
  }


  sendDevice(deviceId) {
    this.router.navigate(["common/add-field"], {
      queryParams: { deviceId: deviceId }
    });
  }

  stopScan() {
    this.show = true;
    BarcodeScanner.showBackground();
    BarcodeScanner.stopScan();
    document.body.style.removeProperty('background-color');
  }

  backPairDevice() {
    this.router.navigate(["/common/pick-device"], {
      queryParams: {
        pair: true
      }
    });
  }


}
